import { InjectionToken } from "@angular/core";

export const CASE_FILTER_OPTIONS = new InjectionToken<CaseFilterOptions>("CASE_FILTER_OPTIONS");

export interface CaseFilterOptions {
  feature?: string;
  filters?: string[];
}
